var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('message.page_not_found')))]),_c('icon-like',{staticClass:"rotate",attrs:{"size":"400px","color":"red"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }